import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import SectionRenderer from "./SectionRenderer";
const minWidthClass = cn("max-w-[1200px] mx-auto w-full");
const StudentHomeContent = (param)=>{
    let { sections , ipSelectProps  } = param;
    var _section_id;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col",
        children: sections.map((section, idx)=>/*#__PURE__*/ _jsx(SectionRenderer, {
                section: section,
                ipSelectProps: ipSelectProps,
                className: minWidthClass
            }, (_section_id = section.id) !== null && _section_id !== void 0 ? _section_id : idx))
    });
};
export default StudentHomeContent;
